<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <div class="flex flex-wrap justify-center relative">

        <div
            class="lg:absolute right-0 bg-beige font-bold text-dark-blue text-lg lg:-mr-16 py-2 w-full lg:w-auto text-center lg:px-16 uppercase">
          {{ $trans('app.package') }} {{ submission.package.name }}
        </div>

        <div class="w-full mt-3 lg:mt-0">
          <p class="uppercase text-sm font-bold text-medium-blue">Test : {{ $page.props.survey.title[$locale()] }}</p>
          <h2 class="text-2xl text-black my-2">{{ $trans('app.test.result-of-your-test') }}</h2>
          <p class="text-sm text-medium-blue">{{ $trans('app.test.test-date') + submission.date }}</p>
          <hr class="w-24 my-4 border-dark-blue">
        </div>

        <div class="flex justify-between w-full">
          <div class="font-bold w-full lg:w-1/2">
            <h3 class="mt-2 lg:mt-4">
              {{ $trans('app.test.how-to-read-your-results') }}
            </h3>
            <p v-html="$trans('app.test.interpretation')" class="font-normal mt-4">
            </p>
            <p class="mt-6 font-beauty text-5xl text-dark-blue">{{ $trans('app.test.talentfully') }}</p>
          </div>
          <div class="mr-10 ml-20 relative hidden lg:block z-10">
            <div class="" style="margin-right: 10%; min-width: 350px;">
              <img src="/images/business-woman@2x.jpg" alt="" class="relative z-10"
                   style="box-shadow: 0 3px 46px 0 rgba(24, 39, 69, 0.18);">
              <img src="/images/bullet.svg" alt="bullets"
                   class="absolute top-0 right-0 transform translate-x-10 -translate-y-10 z-0">
            </div>
            <div class="flex items-center justify-around">
              <bubble-button href="#skills" class="mt-24" v-smooth-scroll>{{
                  $trans('app.test.see-7-skills')
                }}
              </bubble-button>
              <bubble-button href="#coaching" class="mt-24" v-smooth-scroll v-if="submission.package.name === 'gold'">
                {{ $trans('app.packages.book-coaching') }}
              </bubble-button>
            </div>
          </div>
        </div>

      </div>

      <hr class="mt-10 mb-6">

      <div id="skills">
        <h2 class="text-2xl text-black mt-2 mb-6 text-center w-full">{{ $trans('app.test.discover-7-skills') }}</h2>

        <div class="md:flex items-start md:space-x-8">
          <!--Chart-->
          <div class="md:w-5/12">
            <chart class="w-full mb-8" :data="$page.props.sortedSkills"></chart>
            <!-- Advice -->
            <div class="w-full text-center rounded-lg bg-light-blue pb-4 pt-8 px-8 md:mr-6 mb-6 md:mb-0">
              <div class="w-10 h-10 mb-4 mx-auto bg-cover"
                   style="background-image: url('/images/conseil-coach.png');"></div>
              <h3 class="font-bold text-dark-blue"
                  v-html="$trans('app.test.advice.title.'+this.submission.package.name)"></h3>
              <hr class="my-4 border-blue-200">
              <p v-html="$trans('app.test.advice.content.'+this.submission.package.name)"></p>
              <hr class="my-4 border-blue-200">
            </div>
          </div>

          <div class="md:w-7/12 md:pl-8 md:border-l grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- 7 skills -->
            <div class="shadow-lg rounded-lg overflow-hidden cursor-pointer" @click="openVideo">
              <p class="text-sm font-bold py-2 px-3 text-center py-2 uppercase bg-dark-blue text-white">
                {{ $trans('app.test.to-start') }}</p>
              <p class="font-bold text-dark-blue text-center mx-auto pt-4">{{
                  $trans('app.emotional-intelligence')
                }}</p>
              <div class="h-32 m-3 filter p-4 bg-cover bg-center rounded-lg"
                   style="background-image:url('/images/intelligence_emotionnelle_video_thumb.jpeg');"/>
              <modal :show="showVideoModal" @close="showVideoModal = false" max-width="4xl">
                <div class="w-full">
                  <video-player :options="videoOptions">
                    <source src="/storage/IESANSCLIC_x264.mp4" type="video/mp4">
                  </video-player>
                </div>
              </modal>
            </div>
            <div v-for="(skill, key) in $page.props.sortedSkills"
                 class="shadow-lg border border-beige rounded-lg overflow-hidden">
              <conditional-link :link="canAccess(key)" :href="route('submission.details', [submission.uuid, skill.slug])">
                <div class="flex items-center w-full px-3">
                  <div class="rounded-full h-5 w-5" :class="level(skill.level)"></div>
                  <p class="text-sm font-bold py-2 px-3 text-center py-2 uppercase">{{
                      $trans('app.test.' + skill.level)
                    }}</p>
                </div>
                <div class="bg-beige">
                  <p class="font-bold text-dark-blue text-center mx-auto pt-4">{{ skill.title }}</p>
                  <div class="flex items-center justify-center h-32 m-3 filter p-4 bg-cover bg-center rounded-lg"
                       :style="`background-image:url('/storage/${skill.thumbnail_url}');`">
                    <div
                        class="flex items-center justify-center h-16 w-16 rounded-full bg-white bg-opacity-75 text-dark-blue">
                      <svg width="24" height="26" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18 8.76795C19.3333 9.53775 19.3333 11.4623 18 12.2321L3.75 20.4593C2.41667 21.2291 0.750001 20.2668 0.750001 18.7272L0.750002 2.27276C0.750002 0.733157 2.41667 -0.229093 3.75 0.540708L18 8.76795Z"
                            fill="currentColor"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div
                    class="absolute inset-0 p-4 bg-light-blue bg-opacity-95 mx-auto font-bold text-center flex flex-col items-center justify-center rounded-b-lg"
                    v-if="key >= maxAuthorized">
                  <p class="mb-6">{{ skill.title }}</p>
                  <p class="uppercase text-sm">{{ $trans('app.upgrade-description') }}</p>
                  <bubble-link :href="route('submission.select_package', {submission: submission.uuid, upgrade: true})"
                               class="mt-4">{{ $trans('app.upgrade') }}
                  </bubble-link>
                </div>
              </conditional-link>
            </div>
          </div>
        </div>
      </div>

      <!--Meeting-->
      <hr class="mt-10 mb-6">

      <div id="coaching" class="flex flex-wrap lg:flex-nowrap justify-between mb-12">
        <div class="lg:w-1/2 pr-10">
          <h2 class="text-2xl text-black mt-2 mb-6">{{ $trans('app.test.going-further') }}</h2>
          <h3 class="text-xl uppercase font-bold text-dark-blue mb-4">{{
              $trans('app.test.schedule-meeting-with-coach')
            }}</h3>
          <p v-html="$trans('app.test.schedule-meeting-explanation')"></p>
        </div>
        <div class="mt-8 mx-auto">
          <div class="rounded-full shadow-lg justify-center mx-auto h-56 w-56 overflow-hidden">
            <img src="/images/meeting.jpg" alt="Photo coach" class="object-cover h-full w-full">
          </div>
          <bubble-button type="inverted-plain" class="mt-6" v-if="submission.package.name === 'gold'"
                         @click="scheduleMeeting">{{ $trans('app.test.schedule-meeting-button') }}
          </bubble-button>
          <div class="w-2/3 p-4 bg-gray-200 mx-auto mt-4 font-bold text-center flex flex-col items-center rounded-lg"
               v-if="submission.package.name !== 'gold'">
            {{ $trans('app.upgrade-description') }}
            <bubble-link :href="route('submission.select_package', submission.uuid)" class="mt-4">{{
                $trans('app.upgrade')
              }}
            </bubble-link>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import BubbleButton from '@/Components/BubbleButton'
import BubbleLink from '@/Components/BubbleLink'
import ConditionalLink from '@/Components/ConditionalLink'
import Chart from "@/Components/Chart"
import Modal from '@/Jetstream/Modal'
import VideoPlayer from "@/Components/VideoPlayer";

export default {
  components: {AppLayout, BubbleButton, BubbleLink, ConditionalLink, Chart, Modal, VideoPlayer},

  props: {
    submission: Object
  },

  data() {
    return {
      showVideoModal: false,
      videoOptions: {
        controls: true,
        fluid: true,
        height: 200,
      },
    }
  },

  mounted() {
    this.fillData()
  },

  created() {
    if (this.submission.package.name === 'gold') {
      let calendlyScript = document.createElement('script');
      calendlyScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
      calendlyScript.setAttribute('type', 'text/javascript');
      calendlyScript.setAttribute('async', "");
      document.body.appendChild(calendlyScript);

      let calendlyStyle = document.createElement('link');
      calendlyStyle.setAttribute('href', "https://assets.calendly.com/assets/external/widget.css");
      calendlyStyle.setAttribute('rel', 'stylesheet');
      document.head.appendChild(calendlyStyle);
    }
  },

  computed: {
    maxAuthorized() {
      if (this.submission.package.name === 'silver' || this.submission.package.name === 'gold' || this.submission.package.name === 'diamond') {
        return 7;
      }
      // else if (this.submission.package.name === 'bronze') { return 3; }
      else {
        return 0;
      }
    },
    resolveRoute() {
      return this.route();
    }
  },

  methods: {
    level(result) {
      switch (result) {
        case ('develop'):
          return 'bg-red-500 text-white';
          break;
        case ('improve'):
          return 'bg-yellow-400 text-white';
          break;
        case ('maintain'):
          return 'bg-green-500 text-white';
          break;
      }
    },

    canAccess(key) {
      return key < this.maxAuthorized
    },

    scheduleMeeting() {
      Calendly.initPopupWidget({url: this.$page.props.calendly});
    },

    fillData() {
      this.datacollection = {
        labels: ["2", "3"],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [12, 24]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [15, 18]
          }
        ]
      }
    },

    openVideo() {
      this.showVideoModal = true
    }
  }
}
</script>

<style>

</style>


